// extracted by mini-css-extract-plugin
export default {"field-supporting-text":"field-supporting-text__ca3abd"};